export function MonoLabel({ children, color = "#9DB4FF", className = "" }) {
  return (
    <span
      className={`font-mono text-[10px] tracking-[0.35em] uppercase ${className}`}
      style={{ color }}
    >
      {children}
    </span>
  );
}

export function SectionTitle({ kicker, children, align = "left", maxWidth = "56rem" }) {
  return (
    <div className={align === "center" ? "text-center mx-auto" : ""} style={{ maxWidth }}>
      {kicker && <MonoLabel>{kicker}</MonoLabel>}
      <h2 className="h-display mt-5 text-[40px] md:text-[52px] leading-[1.04]">{children}</h2>
    </div>
  );
}

export function Em({ children }) {
  return <em className="italic font-normal" style={{ color: "#9DB4FF", fontStyle: "italic" }}>{children}</em>;
}

export function Card({ children, className = "", ...rest }) {
  return (
    <div
      className={`relative bg-white/[0.025] border border-white/10 hover:border-[#9DB4FF]/60 transition-colors ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function Divider() {
  return <div className="h-px bg-gradient-to-r from-[#9DB4FF]/60 via-white/10 to-transparent my-1" />;
}
